import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef8c2ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wizard-context" }
const _hoisted_2 = ["disabled", "aria-label", "aria-expanded"]
const _hoisted_3 = ["width", "height", "viewBox"]
const _hoisted_4 = ["cx", "cy", "r", "stroke-width"]
const _hoisted_5 = ["cx", "cy", "r", "stroke", "stroke-width", "stroke-dasharray", "stroke-dashoffset", "transform"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "wizard-context-popup-title" }
const _hoisted_8 = { class: "wizard-context-popup-row" }
const _hoisted_9 = { class: "wizard-context-bar" }
const _hoisted_10 = { class: "wizard-context-popup-row" }
const _hoisted_11 = { class: "wizard-context-popup-row" }
const _hoisted_12 = {
  key: 0,
  class: "wizard-context-popup-row"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  class: "wizard-context-popup-error"
}
const _hoisted_15 = { class: "wizard-context-popup-note" }
const _hoisted_16 = {
  key: 1,
  class: "wizard-context-popup-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_outside_click = _resolveDirective("outside-click")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ElTooltip, {
      effect: "custom",
      placement: "top",
      "show-after": 250,
      disabled: _ctx.open || !_ctx.level?.available
    }, {
      content: _withCtx(() => [
        (_ctx.compacting)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.t("TeggyAssistant.ContextCompacting")), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.t("TeggyAssistant.ContextTooltip", {
              percent: _ctx.percent,
              tokens: _ctx.formatNumber(_ctx.level?.tokensUntilCompaction ?? 0),
            })), 1)
            ], 64))
      ]),
      default: _withCtx(() => [
        _createElementVNode("button", {
          id: "wizard-context-ring",
          class: _normalizeClass(["wizard-context-btn", { 'wizard-context-btn--open': _ctx.open }]),
          type: "button",
          disabled: !_ctx.level?.available,
          "aria-label": _ctx.t('TeggyAssistant.ContextLabel'),
          "aria-haspopup": "dialog",
          "aria-expanded": _ctx.open,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggle')), ["stop"]))
        }, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["wizard-context-ring", { 'wizard-context-ring--spinning': _ctx.compacting }]),
            width: _ctx.GLYPH,
            height: _ctx.GLYPH,
            viewBox: `0 0 ${_ctx.GLYPH} ${_ctx.GLYPH}`,
            "aria-hidden": "true"
          }, [
            _createElementVNode("circle", {
              cx: _ctx.GLYPH / 2,
              cy: _ctx.GLYPH / 2,
              r: _ctx.RADIUS,
              fill: "none",
              stroke: "#edeff2",
              "stroke-width": _ctx.STROKE
            }, null, 8, _hoisted_4),
            _createElementVNode("circle", {
              cx: _ctx.GLYPH / 2,
              cy: _ctx.GLYPH / 2,
              r: _ctx.RADIUS,
              fill: "none",
              stroke: _ctx.ringColor,
              "stroke-width": _ctx.STROKE,
              "stroke-linecap": "round",
              "stroke-dasharray": _ctx.CIRCUMFERENCE,
              "stroke-dashoffset": _ctx.dashOffset,
              transform: `rotate(-90 ${_ctx.GLYPH / 2} ${_ctx.GLYPH / 2})`
            }, null, 8, _hoisted_5)
          ], 10, _hoisted_3))
        ], 10, _hoisted_2)
      ]),
      _: 1
    }, 8, ["disabled"]),
    (_ctx.open && _ctx.level)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wizard-context-popup",
          role: "dialog",
          tabindex: "-1",
          onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('close')), ["esc"])),
          "aria-label": _ctx.t('TeggyAssistant.ContextLabel')
        }, [
          (_ctx.level.available)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t("TeggyAssistant.ContextUsed", { percent: _ctx.percent })), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("TeggyAssistant.ContextTokens", {
              used: _ctx.formatNumber(_ctx.level.usedTokens),
              total: _ctx.formatNumber(_ctx.level.usableTokens),
            })), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: "wizard-context-bar-fill",
                    style: _normalizeStyle({
              width: `${_ctx.level.fraction * 100}%`,
              backgroundColor: _ctx.ringColor,
            })
                  }, null, 4),
                  (_ctx.level.usableTokens > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "wizard-context-bar-tick",
                        style: _normalizeStyle({ left: `${_ctx.thresholdPercent}%` })
                      }, null, 4))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.level.tokensUntilCompaction > 0
              ? _ctx.t("TeggyAssistant.ContextUntil", {
                  tokens: _ctx.formatNumber(_ctx.level.tokensUntilCompaction),
                })
              : _ctx.t("TeggyAssistant.ContextDue")), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t("TeggyAssistant.ContextKeeps", { count: _ctx.level.keepMessages })), 1),
                (!_ctx.level.providerBacked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t("TeggyAssistant.ContextEstimated")), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  id: "wizard-context-compact",
                  class: "wizard-context-compact-btn",
                  type: "button",
                  disabled: _ctx.compacting,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('compact')), ["stop"]))
                }, [
                  (_ctx.compacting)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: "spinner",
                        spin: true
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(_ctx.compacting
              ? _ctx.t("TeggyAssistant.ContextCompacting")
              : _ctx.t("TeggyAssistant.ContextCompactNow")), 1)
                ], 8, _hoisted_13),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t("TeggyAssistant.ContextTranscriptSafe")), 1)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.t("TeggyAssistant.ContextUnavailable")), 1))
        ], 40, _hoisted_6)), [
          [_directive_outside_click, _ctx.outsideClick]
        ])
      : _createCommentVNode("", true)
  ]))
}